import {
	getTranslation,
	language as currentLanguagePack
} from '../../locale/utils/getTranslation';

import { common } from './common.js';
import { settings_page } from './settings_page.js';
import { quest_widget } from './quest_widget.js';
import { status_bar } from './status_bar_element.js';
import { quest_page } from './quest_page.js';
import { bonus_buy_widget } from './bonus_buy_widget.js';
import { double_bonus_chance_widget } from './double_bonus_chance_widget.js';
import { bonus_buy_dialog } from './bonus_buy_dialog.js';
import { bonus_revive_widget } from './bonus_revive_widget.js';
import { bonus_revive_dialog } from './bonus_revive_dialog.js';
import { splash_screen_page } from './splash_screen_page.js';
import { win_highlight_popup } from './win_highlight_popup.js';
import { info_page } from './info_page.js';
import { general_elements } from './general_elements.js';
import { auto_spin } from './auto_spin.js';
import { fastplay_dialogue } from './fastplay_dialogue.js';
import { free_spin_page } from './free_spin_page.js';
import { free_spin_page_win } from './free_spin_page_win.js';
import { free_spin_status_bar } from './free_spin_status_bar.js';
import { bonus_round_dialogue } from './bonus_round_dialogue.js';
import { bonus_round_page } from './bonus_round_page.js';
import { bet_amount } from './bet_amount.js';
import { prompt } from './prompt.js';
import { reel } from './reel.js';
import { game_rules } from './game_rules.js';
import { keys } from './keys.js';
import { DEFAULT_LANGUAGE } from '../../locale/context';

class TextManager {
	langCode = DEFAULT_LANGUAGE;
	langPack = {};

	refreshTextsPack(langCode) {
		if (langCode) this.langCode = langCode;

		window.lm = this.getTextsPack();
		this.langPack = window.lm;
	}

	getTranslationContext() {
		return getTranslation(currentLanguagePack, this.langCode);
	}

	getTextsPack() {
		const t = this.getTranslationContext();

		return {
			...settings_page(t),
			...quest_widget,
			...status_bar(t),
			...quest_page,
			...reel,
			...bonus_buy_widget,
			...double_bonus_chance_widget(t),
			...bonus_buy_dialog(t),
			...bonus_revive_widget,
			...bonus_revive_dialog,
			...splash_screen_page(t),
			...win_highlight_popup,
			...info_page,
			...general_elements,
			...auto_spin(t),
			...fastplay_dialogue(t),
			...free_spin_page,
			...free_spin_page_win,
			...free_spin_status_bar(t),
			...bonus_round_dialogue(t),
			...bonus_round_page(t),
			...bet_amount(t),
			...prompt,
			...common(t),
			...game_rules(t),
			...keys(t)
		};
	}
}

export default TextManager;
export const textManager = new TextManager();
